import React from "react";
import { useParams } from "react-router-dom";
import { Col, Row } from "react-bootstrap";
import { Rating } from "react-simple-star-rating";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { useFetch, useLanguage } from "hooks";
import { Icons } from "components";

const MySwal = withReactContent(Swal);

export default function ReviewForm({ onSubmitted }) {
  const [rating, setRating] = React.useState(20);
  const [comment, setComment] = React.useState("");
  const language = useLanguage(); //language returned from useLanguage hook; it’s an object with current language key --> "value in current language";
  const { book_id } = useParams();
  const [_, reviewFormRequest] = useFetch("User/addBookReview", "POST");
  
  const handleRating = (val) => {
    setRating(val);
  };

  const handleSubmitForm = (e) => {
    e.preventDefault();
    let ratingOutOfFive = rating / 20;

    reviewFormRequest(
      {
        book_id,
        rate: ratingOutOfFive,
        comment: comment,
      },
      null,
      (response) => {
        let newRating = {
          newAvgRating: response.data.avg_rate,
          rate: rating / 20,
          comment: comment,
        };
        onSubmitted(newRating);
        MySwal.fire({
          icon: "success",
          title: language.submit_success,
          text: language.submit_success_message,
          confirmButtonText: "متابعة",
        }).then(() => {
          setRating(0);
          setComment("");
        });
      }
    );
  };

  return (
    <div className="review_form">
      <form onSubmit={handleSubmitForm}>
        <Row>
          <Col xl={8} lg={12} md={12} sm={12} xs={12}>
            <Row className="align-items-center mb-4">
              <Col xl={10} lg={10} md={9} sm={8} xs={6}>
                <h4 className="fw-bold text-black">{language.leaveComments}</h4>
              </Col>
              <Col xl={2} lg={2} md={3} sm={4} xs={6}>
                <Rating
                  onClick={handleRating}
                  ratingValue={rating}
                  rtl={language.direction === "rtl"}
                  fullIcon={<Icons.Star fill="#ffcc00" stroke="#ffcc00" />}
                  emptyIcon={
                    <Icons.Star fill="rgba(0,0,0,0)" stroke="#ffcc00" />
                  }
                />
              </Col>
            </Row>
            <Row>
              <Col xs={12}>
                <div className="position-relative bg-light shadow rounded">
                  <Row>
                    <Col xs={12}>
                      <textarea
                        onChange={(e) => setComment(e.target.value)}
                        className="form-control bg-transparent text-light5 border-0 w-100 py-3 rounded-3"
                        rows={8}
                        value={comment}
                        required
                      />
                    </Col>
                    <Col
                      xl={12}
                      lg={12}
                      md={12}
                      sm={12}
                      xs={12}
                      className="d-flex justify-content-end"
                    >
                      <div className="mx-4 mt-2 mb-4">
                        <button className="btn btn-primary">
                          {language.send}
                        </button>
                      </div>
                    </Col>
                  </Row>
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
      </form>
    </div>
  );
}
